import React from "react";
import {Link} from "react-router";
import FormItem from "./FormItem";
import i18n from 'i18n-js';

import Right from "./Right";
import Panel from "./Panel";

import CoolLoader2 from "./CoolLoader2";
import {api, drawTable, IP} from "./baseFunctions";

import langs from "./langs/phpIndex";

import "./usersPage.css";

export default class UsersPage extends React.Component {
	constructor(){
		super();
		this.getData = this.getData.bind(this);
		this.saveUser = this.saveUser.bind(this);
		this.QRgen = this.QRgen.bind(this);
		this.userForm = this.userForm.bind(this);
		this.renderDeparment = this.renderDeparment.bind(this);
		this.beutifyDepartments = this.beutifyDepartments.bind(this);
		this.saveDepartment = this.saveDepartment.bind(this);
		this.getDepartments = this.getDepartments.bind(this);
		this.showDepLvl = this.showDepLvl.bind(this);
		this.removeUsr = this.removeUsr.bind(this);
		this.genQR = this.genQR.bind(this);
		this.overviewTable = false;
		this.state = {
			users: [],
			depStruct: false,
			deparments: [],
			rawDepartments: {},
			sheets: [],
			tempUser: {},
			tempDep: {},
			firms: [],
			groups: [],

			locale: {},

			QRdata: false,
		};
	}
	componentDidMount(){
		this.getData();
		if(this.props.location.pathname.indexOf("gen-qr") !== -1)
		{
			this.genQR();
		}
	}

	componentDidUpdate(props)
	{
		if(this.props.params.id && this.props.params.id !== props.params.id)
		{
			if(document.URL.includes("/department/"))
			{
				const tempDep = this.state.deparments.find((d) => d.id === Number(this.props.params.id));
				if(tempDep)
				{
					this.setState({
						tempDep
					});
				}
			}else{
				const tempUser = this.state.users.find((d) => d.id === Number(this.props.params.id));
				if(tempUser)
				{
					this.setState({
						tempUser
					});
				}
			}
		}
	}
	genQR(id){
		if(this.state.QRdata !== false)
		{
			this.setState({QRdata: false});
		}
		if(!id)
		{
			id = this.props.params.uid;
		}
		api("POST", {"type": "createQRlogin", id}, (d) => {
      if(!d.error)
      {
      	this.setState({
      		QRdata: d.data
      	});
      }
    }, this.props.auth, 1);
	}
	removeUsr(id)
	{
		var sure = window.confirm(langs[this.props.lang].REMOVE_USR_MSG + id);
		if(!sure)
		{
		return 1;
		}
		api("POST", {"type": "deleteUsr", id: id}, (d) => {
		if(!d.error)
		{
			this.getData();
		}
		}, this.props.auth, true);
	}

	getUserInfo()
	{
		this.setState({groups: []});
		api("POST", {"type": "getFirmGroups", "id": this.props.params.id}, (d) => {
			if(!d.error)
			{
				this.setState({groups: d.data});
			}
		}, this.props.auth, 1);
	}

	_datatableTimeout;
	getData()
	{
		this.getUserInfo();
		api("POST", {"type": "getUsers"}, (d) => {
      if(!d.error)
      {
      	if(this.props.params.id)
      	{
			  this.getUserInfo();
			this.setState({users: d.data, tempUser: d.data.find((d) => d.id === this.props.params.id)});
      	}else{
      			this.setState({users: d.data});
      	}

		clearTimeout(this._datatableTimeout);
      	this._datatableTimeout = setTimeout(() => {
			if(this.overViewTable && this.overViewTable.fnDestroy)
			{
			  this.overViewTable.fnDestroy();
			}
			this.overViewTable = window.$("#ras").DataTable(langs[this.props.lang].DATA_OPTIONS);
			// console.log(langs[this.props.lang].DATA_OPTIONS);
			// console.log("Datatable!", this.overViewTable);
		  }, 1000);
      }
	}, this.props.auth, 1);
	
    if(this.props.rank === -1)
    {
    	api("POST", {"type": "getFirms"}, (d) => {
    		this.setState({
    			firms: d.data
    		});
    	},this.props.auth);
    }
	api("POST", {"type": "firmRAsheets"}, (d) => {
		if(!d.error)
		{
			this.setState({sheets: d.data});
		}
	}, this.props.auth, 1);

	api("POST", {"type": "getLocales"}, (d) => {
		if(!d.error)
		{
			this.setState({locale: d.data});
		}
	}, this.props.auth, 1);

		api("POST", {"type": "getDepartments"}, (d) => {
      if(!d.error)
      {
				// let rawDeps = {};
				// let getDeps = (data) => {
				// 	rawDeps[data.id] = data.name;
				// 	for(let i = 0; i < data.subDepartments.length; i++)
				// 	{
				// 		getDeps(data.subDepartments[i]);
				// 	}
				// };
				// d.data.map((d) => getDeps(d));
		  this.setState({
			  deparments: d.data.ids,
			  depStruct: d.data.data,
		});
      }
    }, this.props.auth, 1);
	}
	showDepLvl(key, path)
	{
		const currDeps = [...this.state.deparments];
		var targetDep = currDeps[key];
		for(var i = 0; i < path.length; i++)
		{
			targetDep = targetDep.subDepartments[path[i]];
		}
		targetDep.show = !targetDep.show;

		this.setState({deparments: currDeps});
	}
	getDepartments(data, key, depKey, level, path)
	{
		var ret = [];
		//console.log(data);
		ret.push({
			id: data.id,
			name: data.name,
			linkedTo: false,
			level,
		});
		if(data.subDepartments.length > 0)
		{
			data.subDepartments.map((subD, subI) => 
				this.getDepartments(subD, key, subI, level + 1, [...path, subI]).map((subSubD, subSubI) => ret.push({
					id: subSubD.id,
					name: subSubD.name,
					level: subSubD.level,
					linkedTo: data.id
				}))
			);
		}
		return ret;
	}
	renderDeparment(data, key, depKey, level, path)
	{
		const LANG = langs[this.props.lang];
		let t = level / 40;
		let test = (t, b, c, d) => {
			t /= d;
			t--;
			return c * Math.sqrt(1 - t*t) + b;
		};
		let tempA = (test(t, 0.005, 0.22, 0.865) * 255);
		const ALPHA = 255 - tempA;
		//0.72
		//console.log("ALPHA #", level, "=", ALPHA);
		return (
			<tr key={key + "-" + depKey + "-" + path.length} style={{backgroundColor: "rgb(" + ALPHA + ", " + ALPHA + ", " + ALPHA + ")"}} className="depFix">
				<td colSpan="4">
					<table style={{width: "100%"}}>
						<tbody>
							<tr className="even pointer" id="link_15" data-children="0" style={{color: "rgb(" + tempA + ", " + tempA + ", " + tempA + ")"}}>
						    <td className=" " style={{"paddingLeft": (level * 10) + "px"}}>
						    	{data.name}
						    </td>
						    <td className=" " style={{textAlign: "right"}}>
						    	<a className="toggleA" style={data.subDepartments.length > 0 ? {cursor: "pointer", color: "rgb(" + tempA + ", " + tempA + ", " + tempA + ")"} : {visibility: "hidden"}} onClick={() => this.showDepLvl(key, path)}>
						    			{LANG.DEP_SHOW_HIDE}
						    	</a>
						    </td>
						    <td className=" last" style={{textAlign: "center", width: "100px", display: "none"}}>
						       <a href="#" style={{color: "rgb(" + tempA + ", " + tempA + ", " + tempA + ")"}}>{LANG.EDIT}</a>
						    </td>
							</tr>
							{
								data.show ?
									data.subDepartments.map((subD, subI) => this.renderDeparment(subD, key, subI, level + 1, [
											...path,
											subI
										]))
								: null
							}
						</tbody>
					</table>
				</td>
			</tr>
			);
	}
	/*renderDeparment(dep, key, level, isSub, currPath)
	{
		return (
			<tr>
				<td colSpan="4">
					<table style={{width: "100%"}}>
						<tr className="even pointer" id="link_15" data-children="0">
					    <td className=" " style={{"paddingLeft": (level * 10) + "px"}}>
					    	{dep.name}
					    </td>
					    <td className=" ">
					    	<a className="toggleA" onClick={() => this.showDepLvl(key, level)}>Vis/skjul underafdelinger</a>
					    </td>
					    <td className=" last">
					       <a href="users.php?editDepartment=10">Ret</a>
					    </td>
						</tr>
						{
							dep.show ?
								dep.subDepartments.map((subD, subI) => this.renderDeparment(subD, key, level + 1, subI))
							: null
						}
						
					</table>
				</td>
			</tr>
			);
	}*/
	userForm(e)
	{
		window.test = e.target;
		const target = e.target;
		const tempUsr = {...this.state.tempUser};
		if(target.name.includes("group_"))
		{
			const key = Number(target.name.split("group_")[1]);
			if(!tempUsr.groups)
			{
				tempUsr.groups = {};
			}
			tempUsr.groups[key] = [...target.options].filter(d => !d.selected).map((d) => Number(d.value));
		}else if(target.name === "raSheets" || target.name === "jumpableDepartments")
		{
				tempUsr[target.name] = [...target.selectedOptions].map((d) => d.value);
		}else{
			if(target.nodeName === "INPUT" && target.type === "checkbox")
			{
				tempUsr[target.name] = target.checked ? target.value : (target.dataset.falseVal || "0");
			}else{
				tempUsr[target.name] = target.value;
			}
				
		}
		// console.log(tempUsr);
		//console.log(target.name, target.value);
		this.setState({tempUser: tempUsr});
	}

	depForm(e)
	{
		const target = e.target;
		const tempDep = {...this.state.tempDep};


		tempDep[target.name] = target.value;
		this.setState({tempDep});
	}

	saveDep(e)
	{
		e.preventDefault();

		const isEditing = this.props.params.id ? 1 : 0;
		const dep = {...this.state.tempDep};
		const LANG = langs[this.props.lang];
		var shouldSend = 0;

		if(dep.name && dep.name.length === 0)
		{
			alert(i18n.t("Afdelings navnet må ikke være tomt"));
		}else{
			shouldSend = 1;
		}
		
		if(shouldSend)
		{
			api("POST", {"type": isEditing ? "updateDepartment" : "addDepartment", data: {...dep, id: Number(this.props.params.id)}}, (d) => {
				if(!d.error)
				{
					alert(isEditing ? i18n.t("Afdelingen er opdateret!") : i18n.t("Afdelingen er tilføjet!"));
					this.getData();
				}else if(d.msg)
				{
					alert(d.msg);
				}
			}, this.props.auth, 1);
		}
	}

	saveUser(e)
	{
		//console.log("Saving", this.state.tempUser);
		e.preventDefault();

		const isEditing = this.props.params.id ? 1 : 0;
		console.log("Temp usr", this.state.tempUser);
		const usr = {...this.state.tempUser};//this.state.users.find((d) => d.id == this.props.params.id)};
		const LANG = langs[this.props.lang];
		var shouldSend = 0;
		if(!isEditing)
		{
			if(!usr.raSheet)
			{
				usr.raSheet = [];
			}
			if(!usr.raSheets)
			{
				usr.raSheets = [];
			}
			if(usr.pass !== usr.repeatPass)
			{
				alert(LANG.PASS_NOT_ALIKE);
			}else if(usr.mail !== usr.repeatMail)
			{
				alert(LANG.MAILS_NOT_ALIKE);
			}else if(!usr.rank || usr.rank === "NaN")
			{
				alert(LANG.USER_RANK_MISSING);
			// }else if(!usr.departmentList || usr.departmentList === "NaN")
			// {
			// 	alert(LANG.DEPARTMENT_MISSING);
			}else{
				shouldSend = 1;
			}
		}else{
			if(usr.pass && usr.repeatPass && usr.pass !== usr.repeatPass)
			{
				alert(LANG.PASS_NOT_ALIKE);
			}else if(usr.repeatMail && usr.mail && usr.mail !== usr.repeatMail)
			{
				alert(LANG.MAILS_NOT_ALIKE);
			}else if(usr.rank && usr.rank === "NaN")
			{
				console.log(usr, usr.rank);
				alert(LANG.USER_RANK_MISSING);
			}else if(usr.department && usr.department === "NaN")
			{
				alert(LANG.DEPARTMENT_MISSING);
			}else{
				shouldSend = 1;
			}
		}
		if(shouldSend)
		{
			/*if(usr.department)
			{
				usr.departmentartment = usr.department;
				delete usr.department;
			}*/
			// usr.raSheets = [
			// 	...usr.raSheets,
			// 	...this.state.sheets.filter((d) => d.hidden !== "0" && usr.raSheets.indexOf(d.id) === -1).map((d) => d.id)
			// ];

			if(usr.departmentList)
			{
				usr.department = Number(usr.departmentList[0]);
			}

			api("POST", {"type": isEditing ? "updateUser" : "addUser", data: {...usr, id: Number(this.props.params.id)}}, (d) => {
	      if(!d.error)
	      {
	      	alert(isEditing ? "Brugeren er opdateret!" : "Brugeren er tilføjet!");
	      	this.getData();
	      }else if(d.msg)
	      {
	      	alert(d.msg);
	      }
	    }, this.props.auth, 1);
		}
	}

	saveDepartment(e){
		e.preventDefault();
		api("POST", {"type": "addDepartment", data: {
			name: this.refs.depName.value,
			ref: Number(this.refs.depRef.value),
		}}, (d) => {
	      if(!d.error)
	      {
	      	alert("Afdelingen er oprettet!");
	      	this.refs.depName.value = "";
	      	this.getData();
	      }
	    }, this.props.auth, 1);
	}

	buildDepTable(){
		const LANG = langs[this.props.lang];

		let rows = [["ID", "Name", ""]];
		let depths = [];
		const getDeps = (dep, depth = 0) => {
			rows.push([
				dep.id,
				dep.name,
				dep.linkedTo !== null && <Link to={"/users/edit/department/" + dep.id} onClick={() => {
					this.setState({tempDep: dep});
					// requestAnimationFrame(() => this.getUserInfo());
				}}>{LANG.EDIT}</Link>
			]);
			depths.push(depth);
			dep.children.map(child => getDeps(child, depth + 1));
		};
		if(this.state.depStruct)
		{
			getDeps(this.state.depStruct);
		}
		return drawTable(rows, depths.map(i => ({paddingLeft: ((i * 18) + 15) + "px"})), undefined, undefined, 2);
	}
	beutifyDepartments(root, selected, disallowID)
	{
		// console.log("Beutify deps", root);
		let deps = [];
		const depthFunc = (dep, depth = 0) => {
			deps.push({
				...dep,
				level: depth
			});
			dep.children.forEach(child => depthFunc(child, depth + 1));
		};
		if(root)
		{
			depthFunc(root);
		}

		//console.log("Beutify", arr, this.state.deparments);
			return deps.map((d, key) => {
				let extras = "";
				if(d.level > 0)
				{
					for(let i = 0; i < d.level; i++)
					{
						extras += "--";
					}
					extras += ">";
				}
				let check = typeof selected === "object" ? (selected.indexOf(d.id) !== -1) : (selected === d.id);
				// console.log(selected, "===", d.id);
				if(check)
				{
					// console.log("Check me", d);
				}
				if(d.id === disallowID)
				{
					return null;
				}
				return (<option key={"dep" + key} value={d.id} selected={check}>{extras} #{d.id} {d.name}</option>);
			});
	}

	getSubKPIs(department)
	{
		const findDep = (curr) => {
			if(curr.id === department)
			{
				return curr;
			}
			if(curr.children.length > 0)
			{
				return curr.children.find(child => findDep(child));
			}
			return false;
		};
		const getIDs = (dep) => {
			const children = dep.children || [];
			return [
				...children.map(child => child.id),
				...children.map(child => getIDs(child).flat()).flat(),
			]
		};

		const dep = findDep(this.state.depStruct);
		if(dep)
		{
			const IDs = getIDs(dep).filter(ID => ID !== department);
			const allKPIs = IDs.map(id => Number(this.state.deparments.find(dep => dep.id === id).KPI || 0)).reduce((a, b) => a + b, 0);
			return allKPIs;
		}
		return 0;
	}

	QRgen()
	{
		api("POST", {"type": "createQRlogin", data: {type: "QR_USR", firm: "1"}}, (d) => {
			console.log(d);
			this.refs.qrRes.value = JSON.stringify({
				"type": "DECODE_CMD",
				"data": d.data,
			});
		}, this.props.auth, 1);
	}
	render(){
		const LANG = langs[this.props.lang];
		const isEditing = this.props.params.id ? 1 : 0;
		const userData = isEditing ? this.state.users.find((d) => d.id == this.props.params.id) : false;
		const depData = isEditing ? this.state.deparments.find((d) => d.id == this.props.params.id) : false;
		const IS_EDITING_DEPARTMENT = document.URL.includes("/department/") && this.props.params.id && depData;
		
		const appLang = {
			"DK": "da-DK",
			"EN": "en-US"
		};
		const APP_LANG = this.state.locale[appLang[this.props.lang]];

		var departments = [];
		if(this.props.location.pathname === "/users/new" || this.props.location.pathname === "/users/newDepartment" || isEditing)
		{
			// this.state.deparments.map((d, key) => {
			// 	this.getDepartments(d, key, 0, 0, []).map((dep, key) => departments.push(dep));
			// });
			
			/*for(var i = 0; i < this.state.sheets.length; i++)
			{

			}*/
		}
		//const departments = isEditing ? ["hej"] : [];
		const QR_DATA = JSON.stringify({"type":"LOGIN","data":this.state.QRdata});

		let subKPI = IS_EDITING_DEPARTMENT && this.props.rank === -1 ? this.getSubKPIs(Number(this.props.params.id)) : 0;
		return (
			<Right title={LANG.Brugere} token={this.props.auth} lang={this.props.lang}>
				{
					this.props.location.pathname.indexOf("gen-qr") !== -1 ?
						<Panel title={LANG.QR_LOGIN}>
						{
							typeof this.state.QRdata === "boolean" ?
							null 
							:
							<div key={this.state.QRdata}>
								<div>
									<img src={"https://api.qrserver.com/v1/create-qr-code/?size=200x200&data=" + QR_DATA + "&format=svg"}/>
								</div>
							</div>
						}
							
						</Panel>
					: null
				}
				{
					this.props.location.pathname === "/users/newDepartment" && this.props.rank === -1 ?
						<Panel title={isEditing ? LANG.EDIT_DEPARTMENT : LANG.CREATE_DEPARTMENT}>
							<form onSubmit={this.saveDepartment} method="POST">
								<FormItem name={LANG.NAME} must={1}>
									<input type="text" required={true} className="form-control col-md-7 col-xs-12" name="name" ref="depName"/>
								</FormItem>
								<FormItem name={LANG.DEPARTMENT_TO} must={1}>
									<select className="form-control col-md-7 col-xs-12" ref="depRef">
										{
											this.beutifyDepartments(this.state.depStruct, false).map((d, key) => {
												return d;
											})
										}
									</select>
								</FormItem>
								<FormItem>
	                <button ref="send" type="submit" className="btn btn-success">{isEditing ? LANG.EDIT_DEPARTMENT : LANG.CREATE_DEPARTMENT}</button>
	              </FormItem>
              </form>
						</Panel>
					: null
				}

				
	{
      		IS_EDITING_DEPARTMENT  ?
      			<Panel title={i18n.t("Ret afdeling")} key={this.props.params.id}>
      				<form action="" onChange={e => this.depForm(e)} onSubmit={e => this.saveDep(e)}>

					<FormItem name={LANG.NAME} must={1}>
			            <input type="text" required={true} className="form-control col-md-7 col-xs-12" name="name" defaultValue={isEditing ? depData.name : ""}/>
			          </FormItem>
					<FormItem name={i18n.t("Underafdeling til")} must={1}>
			            <select className="form-control col-md-7 col-xs-12" name="linkedTo" multiple style={{height: "300px"}}>
			            	{
			            		this.beutifyDepartments(this.state.depStruct, [
									depData.linkedTo, 
									// ...(userData.jumpableDepartments ? userData.jumpableDepartments.split(",") : []).map(d => Number(d)),
								], depData.id).map((d, key) => {
			            			return d;
			            		})
			            	}
			            </select>
			          </FormItem>

						{
							this.props.rank === -1 && <FormItem name={`KPI (${subKPI} fra underafdelinger)`} must={1}>
								<input type="number" required={true} className="form-control col-md-7 col-xs-12" name="kpi" defaultValue={isEditing && depData.KPI ? depData.KPI : 0}/>
							</FormItem>
						}
							
					<FormItem>
	                <button ref="send" type="submit" className="btn btn-success">{isEditing ? LANG.UPDATE : LANG.ADD}</button>
	              </FormItem>
              </form>
						</Panel>
      		: null
      	}

      	{
      		this.props.location.pathname === "/users/new" || (!document.URL.includes("/department/") && this.props.params.id && userData) ?
      			<Panel title={isEditing ? LANG.EDIT_USER : LANG.CREATE_USER} key={this.props.params.id}>
      				<form action="" onChange={this.userForm} onSubmit={this.saveUser}>

					<FormItem>
						<div className="avatar-thumb big" style={{backgroundImage: `url(${IP}/image/${userData.picture})`}}/>
			        </FormItem>
					<FormItem name={LANG.FIRST_NAME} must={1}>
			            <input type="text" required={true} className="form-control col-md-7 col-xs-12" name="firstName" defaultValue={isEditing ? userData.firstName : ""}/>
			          </FormItem>
					<FormItem name={LANG.LAST_NAME} must={1}>
			            <input type="text" required={true} className="form-control col-md-7 col-xs-12" name="lastName" defaultValue={isEditing ? userData.lastName : ""}/>
			          </FormItem>
					 <FormItem name={LANG.PHONE} must={1}>
			            <input type="phone" required={true} className="form-control col-md-7 col-xs-12" name="phone" defaultValue={isEditing ? userData.phone : ""}/>
			          </FormItem>
								<FormItem name={LANG.MAIL_NAME} must={1}>
			            <input type="mail" required={true} className="form-control col-md-7 col-xs-12" name="mail" defaultValue={isEditing ? userData.mail : ""}/>
			          </FormItem>
								<FormItem name={LANG.REPEAT_MAIL_NAME} must={1}>
			            <input type="mail" required={true} className="form-control col-md-7 col-xs-12" name="repeatMail" defaultValue={isEditing ? userData.mail : ""}/>
			          </FormItem>
								<FormItem name={LANG.PASS} must={!isEditing}>
			            <input type="password" required={!isEditing} className="form-control col-md-7 col-xs-12" name="pass"/>
			          </FormItem>
					 <FormItem name={LANG.REPEAT_PASS} must={!isEditing}>
			            <input type="password" required={!isEditing} className="form-control col-md-7 col-xs-12" name="repeatPass"/>
			          </FormItem>
					  {
						  this.props.firm == "1" ?
						  <FormItem name={LANG.RA_WARN}>
							  <div className="col-md-7 col-xs-12">
									<input type="checkbox"  name="raWarn" value="1" falseVal="0" defaultChecked={isEditing ? userData.raWarn == "1" : false}/>
							  </div>
						  </FormItem>
						  : null
					  }
								<FormItem name={LANG.RANK} must={1}>
			            <select required={true} className="form-control col-md-7 col-xs-12" name="rank" defaultValue={isEditing ? userData.rank : ""}>
			            	<option value="NaN"></option>
			            	<option value="1">{LANG.RANKS[0]}</option>
			            	<option value="0">{LANG.RANKS[1]}</option>
							{
								this.props.rank === -1 && <option value="-1">Super-admin</option>
							}
			            </select>
			          </FormItem>
					<FormItem name={LANG.LANGUAGE} must={1}>
						<select required={true} className="form-control col-md-7 col-xs-12" name="lang" defaultValue={isEditing ? userData.lang : ""}>
							<option value="NaN"></option>
							<option value="da-DK">Dansk</option>
							<option value="en-US">English</option>
						</select>
					</FormItem>
					<FormItem name={LANG.DEPARTMENT} must={1}>
			            <select className="form-control col-md-7 col-xs-12" name="jumpableDepartments" multiple style={{height: "300px"}}>
			            	{
			            		this.beutifyDepartments(this.state.depStruct, [
									userData.department, 
									...(userData.jumpableDepartments ? userData.jumpableDepartments.split(",") : []).map(d => Number(d)),
								]).map((d, key) => {
			            			return d;
			            		})
			            	}
			            </select>
			          </FormItem>
					  {
						  this.state.groups.map((group, i) => 
							{
								let lang = APP_LANG ? APP_LANG.find(d => d.key === group.name) : false;
								return (<FormItem name={lang ? lang.value : group.name} key={group.id + "" + group.data.length}>
									<select className="form-control col-md-7 col-xs-12" multiple name={`group_${group.id}`}>
										{
											group.data.map(sheet => <option selected={sheet.disabled === 0} value={sheet.sheetID}>{sheet.name}</option>)
										}
									</select>
								</FormItem>);
							})
					  }
							
			          <FormItem>
	                <button ref="send" type="submit" className="btn btn-success">{isEditing ? LANG.UPDATE_USER : LANG.ADD_USER}</button>
	              </FormItem>
              </form>
						</Panel>
      		: null
      	}
				

				<Panel title={LANG.DEPARTMENTS} add="/users/newDepartment" hidden={1}>
					<CoolLoader2 show={this.state.depStruct === false} type="table"/>
					{this.buildDepTable()}
				</Panel>


				<Panel title={LANG.VIEW} add="/users/new">
					<CoolLoader2 show={this.state.users.length === 0} type="table"/>
					<table className="table table-striped jambo_table bulk_action" id="ras" style={this.state.users.length === 0 ? {display: "none"} : {}}>
            <thead>
                <tr className="headings">
                  <th className="column-title">{LANG.ID}</th>
                  <th className="column-title"></th>
                  <th className="column-title">{LANG.MAIL_NAME}</th>
                  <th className="column-title">{LANG.NAME}</th>
                  <th className="column-title">Points</th>
                  <th className="column-title">{LANG.DEPARTMENT}</th>
                  <th className="column-title"></th>
                  {/* <th className="column-title"></th> */}
                  <th className="column-title"></th>
                </tr>
            </thead>
            <tbody key={this.state.deparments.length}>
            	{
            		this.state.users.filter(d => d.deleted === 0).map((d, key) => 
	            	{
						const dep = this.state.deparments.find(a => a.id == d.department);
						return (<tr className="headings" key={"user" + key}>
						<td className="column-title">{d.id}</td>
						<td className="column-title">
							<div className="avatar-thumb" style={{backgroundImage: `url(${IP}/imageThumb/${d.picture})`}}/>
						</td>
						<td className="column-title">{d.mail}</td>
						<td className="column-title">
							<Link to={"/user/" + d.id}>
							{d.firstName} {d.lastName}
							</Link>
						</td>
						<td className="column-title">
							<i className="fa fa-circle" style={{marginRight: "5px", fontSize: "9px", color: "gold"}}/>
							{d.points}
							</td>
						<td className="column-title">{dep ? dep.name : ""}#{d.department}</td>
						<td className="column-title">
							<Link to={"/users/edit/" + d.id} onClick={() => {
								this.setState({tempUser: d});
								requestAnimationFrame(() => this.getUserInfo());
							}}>{LANG.EDIT}</Link>
						</td>
						{/* <td className="column-title">
							<Link to={"/users/gen-qr/" + d.id} onClick={() => this.genQR(d.id)}>{LANG.QR_LOGIN}</Link>
						</td> */}
						<td className="column-title">
							<Link to="/users" onClick={() => this.removeUsr(d.id)}>{LANG.REMOVE}</Link>
						</td>
					  </tr>);
					})
            	}
	            
            </tbody>
        </table>
				</Panel>
			</Right>);
	}
}


// WEBPACK FOOTER //
// ./src/components/UsersPage.js